export const SET_EXPORT_SHIPMENT = 'SET_EXPORT_SHIPMENT'

export const SHIPMENT_FETCHING = 'SHIPMENT_FETCHING'
export const SHIPMENT_CLEAR_ERROR = 'SHIPMENT_CLEAR_ERROR'
export const SHIPMENT_ERROR = 'SHIPMENT_ERROR'
export const SET_EXPORT_SHIPMENT_CONTEXT = 'SET_EXPORT_SHIPMENT_CONTEXT'
export const CLEAR_SHIPMENT = 'CLEAR_SHIPMENT'

export const TRANSPORT_CLEAR_ERROR = 'TRANSPORT_CLEAR_ERROR'
export const TRANSPORT_FETCHING = 'TRANSPORT_FETCHING'
export const CLEAR_TRANSPORT = 'CLEAR_TRANSPORT'
export const SET_TRANSPORT = 'SET_TRANSPORT'
export const TRANSPORT_ERROR = 'TRANSPORT_ERROR'

export const DROP_FETCHING = 'DROP_FETCHING'
export const ADD_DROP_UNITS = 'ADD_DROP_UNITS'
export const DROP_ERROR = 'DROP_ERROR'
export const DROP_CLEAR_ERROR = 'DROP_CLEAR_ERROR'

export const EXPORT_QUOTE_LIST_CLEAR_ERROR = 'EXPORT_QUOTE_LIST_CLEAR_ERROR'
export const EXPORT_QUOTE_LIST_FETCHING = 'EXPORT_QUOTE_LIST_FETCHING'
export const EXPORT_SET_QUOTE_LIST = 'EXPORT_SET_QUOTE_LIST'
export const EXPORT_QUOTE_LIST_ERROR = 'EXPORT_QUOTE_LIST_ERROR'
export const EXPORT_CLEAR_QUOTE_LIST = 'EXPORT_CLEAR_QUOTE_LIST'